// extracted by mini-css-extract-plugin
module.exports = {"container":"Data_container__-76v1"};